import { Badge, BadgeProps } from "@chakra-ui/react";
import { RetailerType } from "__generated__/gql/graphql";
import { RETAILER_TYPE_LABELS } from "components/Shared/RetailerDirectory/RetailerTypeCheckboxes";

type Props = BadgeProps & {
  retailerType: RetailerType;
};

export default function RetailerTypeBadge({ retailerType, ...rest }: Props) {
  return (
    <Badge variant="outline" {...rest}>
      {RETAILER_TYPE_LABELS[retailerType]}
    </Badge>
  );
}
